/* eslint-disable @typescript-eslint/no-floating-promises */
import ApexCharts from 'apexcharts'
import { Flex } from '@chakra-ui/react'
import { useEffect } from 'react'
import { iIndicador, iPeriodo } from '../..'
import { FormatarNumero } from '../../../../../Utils/Helper'

interface BarChartProps {
  id: string
  // valorMaximo: number
  indicador?: iIndicador
  periodoInicial?: number
  periodoFinal?: number
}

export const IndicadorVariosPeriodosChart: React.FC<BarChartProps> = ({ id, indicador, periodoInicial, periodoFinal }) => {
  function GetAcumulado(periodo: iPeriodo, index: number): number {
    let response = 0
    if (indicador?.tipoMeta === 5) {
      return periodo.meses[index].real ?? 0
    }
    for (let i = 0; i < index + 1; i++) {
      response += periodo.meses[i].real ?? 0
    }

    return response
  }

  const coresPorAno = ['#2A78D6', '#EB6834', '#1BAF7A', '#EDA100', '#E87BA4', '#008300', '#4A3AA7', '#E34948']

  function ReturnSeries(): any[] {
    const response: any[] = []
    indicador?.periodos.filter(e => {
      if (periodoInicial) {
        if (periodoInicial > e.ano) {
          return null
        }
      }
      if (periodoFinal) {
        if (periodoFinal < e.ano) {
          return null
        }
      }

      return e
    }).forEach((e) => {
      response.push({
        name: 'Valor Acumulado' + ` - ${e.ano}`,
        data: e.meses.map((m, i) => {
          return GetAcumulado(e, i)
        })
      })
      response.push({
        name: 'Valor Previsto' + ` - ${e.ano}`,
        data: e.meses.map((m, i) => {
          return m.previsto
        })
      })
    })
    return response
  }

  const mesesAbreviados = [
    'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun',
    'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'
  ]
  function GerarGrafico(): void {
    const series = ReturnSeries()
    // cada ano tem uma cor propria, e o previsto repete a cor do acumulado em linha tracejada
    const cores = series.map((e, i) => coresPorAno[Math.floor(i / 2) % coresPorAno.length])
    const tracejado = series.map((e, i) => i % 2 === 0 ? 0 : 6)
    const espessuras = series.map((e, i) => i % 2 === 0 ? 4 : 3)
    const tamanhoMarcadores = series.map((e, i) => i % 2 === 0 ? 6 : 4)

    const options = {
      chart: {
        height: 350,
        type: 'line',
        stacked: false,
        zoom: {
          enabled: false
        }
      },
      markers: {
        size: tamanhoMarcadores
      },
      dataLabels: {
        enabled: false
      },
      colors: cores,
      series: series,
      stroke: {
        width: espessuras,
        dashArray: tracejado
      },
      plotOptions: {
        bar: {
          columnWidth: '20%'
        }
      },
      // yaxis: {
      //   max: valorMaximo
      // },
      xaxis: {
        categories: indicador?.periodos[0].meses.map(e => e.numeroMes).map(e => mesesAbreviados[e - 1])
      },
      yaxis: {
        labels: {
          formatter: function(value: any) {
            return indicador?.tipoMeta === 0 ? `${indicador?.medidaMeta ?? ''}${FormatarNumero(value, indicador)}` : indicador ? `${FormatarNumero(value, indicador)}${indicador?.medidaMeta ?? ''}` : ''
          }
        }
      },
      tooltip: {
        shared: false,
        intersect: true,
        x: {
          show: false
        },
        y: {
          show: true,
          formatter: function(value: any) {
            return indicador?.tipoMeta === 0 ? `${indicador?.medidaMeta ?? ''}${FormatarNumero(value, indicador)}` : indicador ? `${FormatarNumero(value, indicador)}${indicador?.medidaMeta ?? ''}` : ''
          }
        }
      },
      legend: {
        horizontalAlign: 'left',
        offsetX: 40,
        itemMargin: {
          horizontal: 8,
          vertical: 4
        }
      }
    }
    const chart = new ApexCharts(document.querySelector(`#chart-varios-periodos-${id}`), options)
    chart.render()
  }

  useEffect(() => {
    GerarGrafico()
  }, [])
  return (
      <Flex id={`chart-varios-periodos-${id}`} />
  )
}
